import React, { useId, useState } from 'react';

export function searchText(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase();
}

export default function SearchableSelect({
  label, options, value, text, onTextChange, onSelect, onOpen,
  disabled = false, loading = false, placeholder, className = '',
}) {
  const id = useId();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(-1);
  const query = value ? '' : searchText(text);
  const matches = options.filter(option => searchText(`${option.label} ${option.search || ''}`).includes(query));
  const show = open && !disabled;
  const choose = option => {
    onSelect(option);
    setOpen(false);
    setActive(-1);
  };
  return <div className="relative min-w-0">
    <label htmlFor={id} className="block text-xs text-violet-200 mb-1.5">{label}</label>
    <input id={id} role="combobox" aria-autocomplete="list" aria-expanded={show}
      aria-controls={`${id}-list`} aria-describedby={`${id}-status`}
      aria-activedescendant={show && matches[active] ? `${id}-option-${active}` : undefined}
      autoComplete="off" disabled={disabled} value={text} placeholder={placeholder}
      className={className}
      onFocus={() => { setOpen(true); setActive(-1); onOpen?.(); }}
      onClick={() => { setOpen(true); onOpen?.(); }}
      onBlur={() => { setOpen(false); setActive(-1); }}
      onChange={event => { onTextChange(event.target.value); setOpen(true); setActive(-1); }}
      onKeyDown={event => {
        if (event.key === 'Escape') { setOpen(false); setActive(-1); return; }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!show) onOpen?.();
          setOpen(true);
          const next = event.key === 'ArrowDown' ? active + 1 : active < 0 ? matches.length - 1 : active - 1;
          setActive(matches.length ? (next + matches.length) % matches.length : -1);
        }
        if (event.key === 'Enter' && show) {
          event.preventDefault();
          if (matches[active]) choose(matches[active]);
        }
      }} />
    <span id={`${id}-status`} role="status" className="absolute top-full left-0 mt-1 text-xs text-violet-200">
      {loading ? 'Cargando opciones...' : `${matches.length} de ${options.length} coincidencias`}
    </span>
    {show && <ul id={`${id}-list`} role="listbox" aria-label={`${label}: opciones disponibles`}
      className="absolute top-full z-50 mt-6 w-full min-w-[16rem] max-h-64 overflow-auto rounded-xl border border-violet-400/40 bg-[#181024] shadow-2xl">
      {!loading && !matches.length && <li className="px-3 py-2 text-sm text-violet-200">Sin coincidencias</li>}
      {matches.map((option, index) => <li key={option.id} id={`${id}-option-${index}`}
        role="option" aria-selected={value === option.id}
        className={`px-3 py-2 text-sm text-violet-50 cursor-pointer break-words ${active === index || value === option.id ? 'bg-violet-600/50' : 'hover:bg-violet-600/30'}`}
        onMouseDown={event => event.preventDefault()}
        onMouseEnter={() => setActive(index)}
        onClick={() => choose(option)}>
        {option.label}
      </li>)}
    </ul>}
  </div>;
}
